module.exports = __webpack_public_path__ + "static/media/spike.f81369cf.svg";